import React, { useEffect } from "react";
import { Routing } from "./Routing/Routing";
import "./app.css";
import ThemeSelector from "./Theme/ThemeSelector";
import { FAVICON } from "./Utils/variables";

function App() {
  useEffect(() => {
    document.getElementById("mainTitleLogo").href = FAVICON;
  }, []);

  return (
    <div className="App">
      <ThemeSelector>
        <Routing />
      </ThemeSelector>
    </div>
  );
}
export default App;
